export default __webpack_public_path__ + "static/media/ads1.6610e495.png";